import { request } from '@/utils/request'
import { toDictionary } from '@/utils/array'

export function unpack(content) {
    const companies = toDictionary(content.companies, c => c.id)
    const executives = toDictionary(content.executives, e => e.id)

    content.outliers.forEach(o => {
        o.company = companies[o.companyId]
        o.executive = executives[o.executiveId]
        o.transactionTypeName = o.transactionType === 80 ? 'Bought' : 'Sold'
    })

    return content.outliers
}

export async function listOutlierInsiderTransactions() {
    return unpack(await request.get('/api/outlier-insider-transactions'))
}
